import type { AzureTenantState } from '@/app/(blank-layout-pages)/(authenticated)/onboarding/azure/connectAzureTenant';
import { Wizard } from '@/components/wizard/Wizard';
import { useWorkspace } from '@/contexts/useWorkspace';

import { azureConnectTenantFlow } from './azureConnectTenantFlow';

export function AzureConnectTenantWizard({
  onTenantConnectFinish,
}: {
  onTenantConnectFinish: (tenantId: string) => Promise<void>;
}) {
  const { rightPanel } = useWorkspace();

  const onFinish = async (state: AzureTenantState) => {
    if (state.tenantId) {
      await onTenantConnectFinish(state.tenantId);
      return true;
    }
    return false;
  };

  return (
    <Wizard<AzureTenantState>
      hideCloseButton={false}
      onAbort={() => rightPanel.setIsOpen(false)}
      hideBackArrow={false}
      onFinish={onFinish}
      flow={[azureConnectTenantFlow]}
      initialState={{
        onboardingFlow: false,
        tenantConnectMethod: 'terraform',
        subscriptionId: '',
        backup_app_service_principal_id: '',
        restore_app_name: 'EonRestoreApplication',
        restore_app_application_id: '',
        restore_app_service_principal_id: '',
        managed_identity_resource_id: '',
        tenantId: '',
      }}
      title='Connect Azure tenant'
      stepperLabels={['Management app']}
    />
  );
}
